import {
  LitElement,
  html,
  css
} from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js'

// SECTION: Styles
const planPickerStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 12px 0;
    padding: 0;
    border: 0;
    font-family: "Avenir", sans-serif;
    margin-bottom: 15px;
  }

  .sr-only {
    position: absolute;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }

  .group-container {
    display: block;
    position: relative;
    /* transition: border-color 0.2s ease;
    border: 1px solid #ccc; */
  }

  .group-container--selected {
    /* border-color: #333; */
  }

  .group-input {
    position: absolute;
    opacity: 0;
    width: 0px;
    height: 0px;
  }

  .group-input:focus-visible ~ .group-label {
    /* outline: 2px #ccc solid; */
    /* outline-offset: 4px; */
  }

  .group-label {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* padding: 10px; */
    cursor: pointer;
  }

  .group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
  }

  .skio-radio__container {
    display: flex;
    margin-right: 10px;
    color: #ff8e9f;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }

  .group-label:hover .skio-radio {
    opacity: 0.75;
    transform: scale(1);
  }

  .group-container--selected .group-label .skio-radio {
    opacity: 1;
    transform: scale(1);
  }

  .skio-price {
    margin-left: 0;
    vertical-align: middle;
    font-weight: bold;
  }

  .skio-price s {
    margin-right: 4px;
    font-size: 13px;
  }

  .group-content {
    opacity: 1;
    width: auto;
    max-height: 100px;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .group-content p {
    margin: 0.5rem 0 0 0;
    font-size: 13px;
    color: #000;
  }

  /* Hide frequency if not selected */
  .group-container:not(.group-container--selected) .group-content {
    pointer-events: none;
    opacity: 0;
    max-height: 0;
    visibility: hidden;
  }

  .group-title {
    min-width: max-content;
    font-weight: bold;
  }

  .savings {
    /* padding: 0px 8px;
    background-color: #0fa573;
    border: 1px #0fa573 solid;
    border-radius: 4px;
    font-size: 12px;
    color: white; */
  }

  .selling-plan-dropdown {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    margin-top: 5px;
    padding: 8px 30px 8px 10px;
    background-color: #f7f7f7;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px top 50%;
    background-size: 18px;
    border: 0;
    border-radius: 5px;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .skio-frequency.skio-frequency--one {
    background-image: none;
  }

  .skio-frequency span {
    text-transform: lowercase;
  }

  .selling-plan-buttons {
    /* display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px; */
    margin: 0;
    padding: 0;
    border: 0;
    margin-top: 20px;
  }

  .selling-plan-buttons input[type='radio'] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .selling-plan-buttons label {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 15px;
  }

  .selling-plan-buttons input[type="radio"]:checked + label svg {
    fill: #bae8e4;
  }


  .selling-plan-buttons input:focus-visible + label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
  }

  .extra_note {
    font-weight: bold;
  }
[for="group-0-8554266689768"] .free_wipes_text{
  display: none;
[for="group-0-8987564212456"] .free_wipes_text{
  display: none;
}

`

// !SECTION: Styles

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    key: { type: String },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    _availableSellingPlanGroups: { type: Array },
    _selectedSellingPlanGroup: { type: Object },
    _selectedSellingPlan: { type: Object },
    form_id: { type: String },

    externalPriceSelector: { type: String },
  }

  static styles = planPickerStyles

  constructor() {
    super()

    this.key = null
    this.form_id = null

    this.product = null
    this.productHandle = null
    this.selectedVariant = null

    this._availablesellingPlanGroups = null
    this._selectedSellingPlanGroup = null
    this._selectedSellingPlan = null

    this.currency = 'AUD'
    this.language = 'en-AU'
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    this.options = {
      form_id: this.form_id,
      start_onetime: 'true',
      onetime_first: 'true',
      default_subscription: '4 weeks',
      group_border_radius: 5,
      group_border_shadow: true,
      group_border_selected_color: '#000',
      onetime_title: 'One Time',
      subscription_title: 'Subscribe',
      prepaid_title: 'Prepaid',
      discount_format: 'percent',
      discount_style: 'bubble',
      discount_prefix: 'Save',
      discount_suffix: '',
      discount_color: '#0fa573',
      selector_type: 'button'
    }

    this.form = null
    this.variantInput = null

    this.externalPriceSelector = '[skio-external-price]';
  }

  connectedCallback() {
    super.connectedCallback()

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()

    let skio = this;
    document.addEventListener("variantChanged", function(e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    this.startSubscription()

  }

  // SECTION: Element Templates
  radioTemplate = () => {
    return html`
      <div class="skio-radio__container">
        <svg
          width="28"
          height="28"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#000"
            stroke-width="1"
          ></circle>
          <circle
            class="skio-radio"
            cx="12"
            cy="12"
            r="10"
            fill="currentColor"
          ></circle>
        </svg>
      </div>
    `
  }

  sellingPlanDropdown = (group) => {
    return html`
      <select
        class="selling-plan-dropdown"
        @change=${(e) => this.selectSellingPlan(e.target.value)}
      >
        ${group
          ? group.selling_plans.map(
              (selling_plan) =>
                html`
                  <option
                    ?selected=${group.selected_selling_plan.id ===
                    selling_plan.id}
                    value=${selling_plan.id}
                  >
                    ${selling_plan.name}
                  </option>
                `
            )
          : ''}
      </select>
    `
  }

  sellingPlanButtons = (group) => {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        <b>Choose your delivery cycle:</b>
        ${group
          ? group.selling_plans.map(
              (selling_plan) => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${(e) => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}">
                  ${this.radioTemplate()} ${selling_plan.name}
                </label>
              `
            )
          : ''}
          <div class="extra_note">Note: A minimum subscription period of 3 payment cycles applies.</div>
      </fieldset>
    `
  }

  futurePriceText = () => {
    if (!this._selectedSellingPlan) return

    const futurePriceAdjustments = this.futureDiscounts(
      this._selectedSellingPlan
    )
    if (!futurePriceAdjustments.length) return

    return html`
      ${futurePriceAdjustments.map(
        (discount, index) =>
          html` <p>Then save ${discount.percent} on order ${index + 2}+</p> `
      )}
    `
  }
  // !SECTION: Element Templates

  render() {
    if (!this.viable()) return
    var title_suffix = this.getAttribute('discount-suffix'); //CD [add suffix for specific product]
    
    return html`
      <fieldset class="skio-plan-picker">
        <legend class="sr-only">Select subscription plan</legend>

        ${!this.product.requires_selling_plan
          ? html`
              <div
                class="group-container ${this._selectedSellingPlanGroup == null
                  ? 'group-container--selected'
                  : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One Time Purchase"
                  ?checked=${!this._selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.radioTemplate()}

                    <div class="group-title">One Time Purchase -&nbsp;</div>

                    <div class="skio-price">
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                </label>
              </div>
            `
          : ''}
        ${this._availablesellingPlanGroups?.length ?
        this._availablesellingPlanGroups.map(
          (group, index) =>
            html`
              <div
                class="group-container ${this._selectedSellingPlanGroup == group
                  ? 'group-container--selected'
                  : ''}"
              >
                <input
                  id="group-${index}-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="${group.id}"
                  @change=${() => this.selectSellingPlanGroup(group)}
                  ?checked=${this._selectedSellingPlanGroup == group}
                />

                <label class="group-label" for="group-${index}-${this.key}">
                  <div class="group-topline">
                    ${this.radioTemplate()}

                    <div class="group-title">
                      ${group.name == 'Subscription' &&
                      this.options?.subscription_title
                        ? this.options?.subscription_title
                        : group.name}
                            <span class="savings">&amp; Save ${ this.product.id == 8554266689768? '10%' : this.product.id == 8987564212456? '10%' : this.discount(group.selected_selling_plan).percent == '13%' ? '27%' : '35%' }${title_suffix ? ' '+title_suffix : ''} -&nbsp;</span>                        
                    </div>

                    <div class="skio-price">
                       ${this.price(group.selected_selling_plan)}<span>*</span>
                    </div>   
                      <div class="free_wipes_text" style="padding-left: 7px; font-weight: 400;"></div>
                  </div>

                  <div class="group-content">
                    ${this.options?.selector_type == 'dropdown'
                      ? this.sellingPlanDropdown(group)
                      : ''}
                    
                    ${this.options?.show_future_price_adjustments
                      ? this.futurePriceText()
                      : ''}
                    ${this.options?.additional_subscription_content
                      ? html`
                          <p>
                            ${this.options?.additional_subscription_content}
                          </p>
                        `
                      : ''}
                  </div>
                </label>
              </div>

              ${this.options?.selector_type == 'button' && this._selectedSellingPlanGroup ? this.sellingPlanButtons(this._selectedSellingPlanGroup) : ''}
            `
        ) : ''}
      </fieldset>
    `
  }

  bindFormEvents() {
    this.form =
      document.querySelector(`#${this.options?.form_id}`) ||
      this.closest('form[action="/cart/add"]') || this.closest('form[action="/en-nz/cart/add"]')
    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      this.variantInput.addEventListener('change', (e) => {
        this.selectedVariant = this.product.variants.find(
          (variant) => variant.id == e.target.value
        )
      })
    }
  }

  updated = (changed) => {
    const skio = this;
    if (!this.viable()) return

    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
        (selling_plan_group) => selling_plan_group.app_id === 'SKIO'
      )

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this._availablesellingPlanGroups = filteredSellingPlanGroups.filter(
        (selling_plan_group) =>
          selling_plan_group.selling_plans.some((selling_plan) =>
            this.selectedVariant.selling_plan_allocations.some(
              (selling_plan_allocation) =>
                selling_plan_allocation.selling_plan_id === selling_plan.id
            )
          )
      )

      //update selectedSellingPlan value
      if (this._availablesellingPlanGroups?.length) {
        //update each group with a default selected_selling_plan
        this._availablesellingPlanGroups.forEach((group) => {
          group.selected_selling_plan =
            group.selling_plans.find((plan) => plan.name === this._selectedSellingPlan?.name) || 
            group.selling_plans.find((plan) =>
              plan.name
                .toLowerCase()
                .includes(this.options?.default_subscription?.toLowerCase())
            ) || group.selling_plans[0]
        });

        /* if (
          this.options?.start_onetime == 'false' ||
          this.product.requires_selling_plan == true
        ) {
          this.selectSellingPlan(this._availablesellingPlanGroups[0].selected_selling_plan.id)
        } else {
          this.selectSellingPlanGroup(null)
        } */

        /* this.selectSellingPlanGroup(null); */

      }

      this.requestUpdate();
    }

    if (changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document
        .querySelectorAll(`[skio-price][skio-key="${this.key}"]`)
        .forEach((el) => {
          el.innerHTML = this.price(this._selectedSellingPlan)
        })

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this._selectedSellingPlan,
          key: this.key,
        },
      })

      this.dispatchEvent(event)
    }
    
    this.updateForm()
    this.updateExternalPrice();
  }

  // SECTION: Utility Functions
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  log = (...args) => {
    args.unshift('%c[skio plan picker]', 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error = (...args) => {
    args.unshift('%c [skio plan picker]', 'color: #ff0000')
    console.error.apply(console, args)
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.form.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push(
        'No product found. Please pass a product or productHandle to the skio-plan-picker component.'
      )
    }
    if (!this.selectedVariant) {
      errors.push(
        'No variant found. Please pass a product or productHandle to the skio-plan-picker component.'
      )
    }
    if (!this.form) {
      errors.push(
        'No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".'
      )
    }
    if (!this.variantInput) {
      errors.push(
        'No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"'
      )
    }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }
  // !SECTION: Utility Functions

  // update external price
  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this._selectedSellingPlan);
    })
  }

  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this._selectedSellingPlanGroup = group
    this._selectedSellingPlan = group?.selected_selling_plan
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan_id) {
    const selectedGroup = this._availablesellingPlanGroups.find((group) =>
      group.selling_plans.some((plan) => plan.id == selling_plan_id)
    )
    const selectedSellingPlan = selectedGroup.selling_plans.find(
      (plan) => plan.id == selling_plan_id
    )

    selectedGroup.selected_selling_plan = selectedSellingPlan
    this._selectedSellingPlanGroup = selectedGroup
    this._selectedSellingPlan = selectedSellingPlan
  }

  startSubscription() {
    if (window.location.href.indexOf("selling_plan") > -1) {
      this.options.start_onetime = 'false'
    }
  }

  // SECTION: Discount Functions
  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  futureDiscounts(selling_plan) {
    return selling_plan.price_adjustments.reduce((result, price_adjustment) => {
      if (price_adjustment.position !== 1)
        result.push(this.getDiscountFromPriceAdjustment(price_adjustment))
      return result
    }, [])
  }

  getDiscountFromPriceAdjustment(price_adjustment) {
    const discount = {
      percent: '0%',
      amount: 0,
    }
    const price = this.selectedVariant.price
    const compareAtPrice = this.selectedVariant.compare_at_price
      ? this.selectedVariant.compare_at_price
      : price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = Math.round(
          (((compareAtPrice - price_adjustment.value) * 1.0) / compareAtPrice) *
            100.0
        )
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }
  // !SECTION: Discount Functions

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money(
          this.selectedVariant.price - this.discount(selling_plan).amount
        )
      : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.form.querySelector('input[name=selling_plan]')
    let form_button = this.form.querySelector('button[type="submit"]');
    if ($sellingPlan) {
      this.form.querySelectorAll('input[name=selling_plan]').forEach((el) => {
        el.value = this._selectedSellingPlan? this._selectedSellingPlan.id : ''
      })
    }

    // CD Arshit
    if(document.querySelector('.product-single__actions-forms')){
      if(this._selectedSellingPlan != undefined){
        document.querySelector('.product-single__actions-forms').classList.add('addfreeproduct');
        // CD CODE...
        if($('.subscription_meta_price .variant_price').text() != '' || $('.subscription_meta_price .variant_comp_price').text() != ''){
          
          if($('.price_and_comp').length){
            $('.price_and_comp').addClass('hide_message');
          }
          if($('.product-single__actions-forms .product-single__details')){
            $('.product-single__actions-forms .product-single__details').addClass('hide_message');
          }
          if($('.subscription_meta_price')){
            $('.subscription_meta_price').removeClass('hide_message');
          }
        }else{
          if($('.product-single__actions-forms .product-single__details').length){
            $('.product-single__actions-forms .product-single__details').removeClass('hide_message');
          } else if($('.price_and_comp').length){
            $('.price_and_comp').removeClass('hide_message');
          }
        }

        if($('.subscription_onetime_meta_price').length){
          $('.subscription_onetime_meta_price').addClass('hide_message');
        }
        
      }else{
        document.querySelector('.product-single__actions-forms').classList.remove('addfreeproduct');

        // var subscrptn_price_hidden = $(".subscription_onetime_meta_price").hasClass("hide_message") && $(".subscription_meta_price").hasClass("hide_message");
        
        // CD CODE...
        if($('.subscription_meta_price .variant_price').text() != '' || $('.subscription_meta_price .variant_comp_price').text() != ''){
          // if($('.price_and_comp').length){
          //   if(subscrptn_price_hidden) {
          //     $('.price_and_comp').removeClass('hide_message');
          //   } else {
          //     $('.price_and_comp').addClass('hide_message');
          //   }
          // }
          if($('.price_and_comp').length) $('.price_and_comp').addClass('hide_message');
          if(!$('.product-single__actions .product-single__actions-variants').length && !$('.subscription_onetime_meta_price').length){
            if($('.product-single__actions-forms .product-single__details').length){
              $('.product-single__actions-forms .product-single__details').removeClass('hide_message');
            }
          }
          if($('.subscription_meta_price').length){
            $('.subscription_meta_price').addClass('hide_message');
          }
         
        }


        if($('.product-single__actions .product-single__actions-variants').length && $('.subscription_onetime_meta_price').length){

          var current_variant = $('.product-single__actions .product-single__actions-variants').val();
          var current_option_price = $('.product-single__actions .product-single__actions-variants option[value="'+ current_variant +'"]').attr('data-current-price');
          var current_meta_option = $('.product-single__actions .product-single__actions-variants option[value="'+ current_variant +'"]').attr('data-sub-onetime');
           $('.subscription_onetime_meta_price .onetime_variant_comp_price').text(current_meta_option);
           $('.subscription_onetime_meta_price .onetime_variant_price').text(current_option_price);
            // if($('.price_and_comp').length){
            //   if(subscrptn_price_hidden) {
            //     $('.price_and_comp').removeClass('hide_message');
            //   } else {
            //     $('.price_and_comp').addClass('hide_message');
            //   }
            // }
            if($('.price_and_comp').length) $('.price_and_comp').addClass('hide_message');
            if($('.subscription_onetime_meta_price').length){
              $('.subscription_onetime_meta_price').removeClass('hide_message');
            }
            
              if($('.product-single__actions-forms .product-single__details').length){
                $('.product-single__actions-forms .product-single__details').addClass('hide_message');
              }
          
        }
        
      }
    }
    
    form_button.setAttribute('data-sellingplan', this._selectedSellingPlan? this._selectedSellingPlan.id : '')
  }

  // SECTION: Additional Functionality

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this._selectedSellingPlan && {
          selling_plan: this._selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.log('Added item to cart: ', response)
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }

  // !SECTION: Additional Functionality
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent)